import { Pipe, PipeTransform } from "@angular/core";
import { LearningModuleDto } from "src/app/services/api/model/learning-module-dto";

@Pipe({ name: "mapModules" })
export class MapModulesPipe implements PipeTransform {
  public transform(learningModules: LearningModuleDto[]): string {
    return learningModules.map(learningModule => learningModule.name).join(", ");
  }
}
